import { Roll, ROLL_INITIAL_VALUES } from "./Roll";

export interface EdgerRoll extends Roll {
	Diameter: number | null;
	NewDiameter: number | null;
	ScrapDiameter: number | null;
	PassesStatus: string;
	IsActive: boolean | null;
}

export const EDGER_ROLL_INITIAL_VALUES: EdgerRoll = {
	...ROLL_INITIAL_VALUES,
	Diameter: null,
	NewDiameter: null,
	ScrapDiameter: null,
	PassesStatus: "",
	IsActive: true,
};

export interface EdgerRollPassResponse {
	EdgerRollPartId: number;
	PassNumber: number;
	PassStatusCode: string;
	StatusDescription?: string;
	SectionId: number | null;
	SectionName: string | null;
}

export interface EdgerRollPass {
	PassNumber: number;
	PassStatusCode: string;
	StatusDescription?: string;
	Sections: SectionEdgerRollPass[];
}

interface SectionEdgerRollPass {
	SectionId: number;
	SectionName: string;
}
